import {ActiveFiltersAdapter} from '../BaseFilterInterfaces';

/**
 * Adapter for URLSearchParams to work with BaseFilter
 * Handles multiple values per key via getAll()
 * Works with both direct URLSearchParams objects and those from useSearchParams hook
 */
export function createURLSearchParamsAdapter(searchParams: URLSearchParams | null): ActiveFiltersAdapter {
  const params = searchParams || new URLSearchParams();

  return {
    getAll(key: string): string[] {
      return params.getAll(key);
    },

    has(key: string): boolean {
      return params.has(key);
    },

    forEach(callback: (value: string, key: string) => void): void {
      params.forEach(callback);
    },

    get(key: string): string | null {
      return params.get(key);
    }
  };
}
